export default "__VITE_ASSET__CGw49Vbm__"